import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import { ICustomerOverview } from "@rfm/shared-interfaces";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";

@Component({
  selector: "app-subscription-information",
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule],
  templateUrl: "./subscription-information.component.html",
  styleUrls: ["./subscription-information.component.scss"],
})
export class SubscriptionInformationComponent implements OnInit, OnChanges {
  @Input()
  customer_overview = signal<ICustomerOverview | undefined>(undefined);

  hasSubscriptions: boolean = false;

  constructor(private router: Router) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.customer_overview() &&
      this.customer_overview()?.subscriptions &&
      this.customer_overview()?.subscriptions?.data
    ) {
      this.hasSubscriptions = true;
    } else {
      this.hasSubscriptions = false;
    }
  }

  changePlan() {}

  ngOnInit() {}
}
